module.exports = __webpack_public_path__ + "static/media/rupee.407ad734.svg";